// EDIT THIS TEXT FOR FINAL COPY
// This file contains all editable content for the EGTA Board 2025 download page

export const EGTA_BOARD_2025_CONTENT = {
  // Page metadata
  pageTitle: 'EGTA Board 2025 Materials | Syllepsis',
  pageDescription: 'Access your EGTA Board 2025 discussion materials',
  
  // Page header
  headerTitle: 'EGTA Board 2025 Discussion Materials',
  headerSubtitle: 'Enter your details below to receive the board discussion materials by email',
  
  // Form labels and validation
  form: {
    nameLabel: 'Full Name',
    namePlaceholder: 'Your full name',
    emailLabel: 'Work Email',
    emailPlaceholder: 'your.email@company.com',
    consentLabel: 'I agree to receive these materials by email and to be contacted by Syllepsis about related services.',
    submitButton: 'Send Materials',
    submittingButton: 'Sending...',
  },
  
  // Success/Error messages
  messages: {
    success: 'Thanks! Your documents are on their way. Check your inbox.',
    error: '⚠️ Oops, something went wrong. Please try again or email us at info@syllepsis.io.',
  },
  
  // Email configuration
  email: {
    subject: 'EGTA Board: discussion materials',
    greeting: (firstName: string) => `Hi ${firstName},`,
    body: `
      <p>Thank you for your interest in our EGTA Board presentation materials.</p>
      <p>Attached you'll find the following discussion materials:</p>
      <ul>
        <li>Board Topic Summary</li>
        <li>AI Change Playbook</li>
        <li>Executive Q&A Prep</li>
        <li>Risk & Governance Primer</li>
      </ul>
      <p>If you have any questions or would like to discuss how we can support your board's AI strategy, please don't hesitate to reach out.</p>
    `,
    signature: `
      <p>Best regards,<br>
      The Syllepsis Team<br>
      <a href="mailto:info@syllepsis.io">info@syllepsis.io</a></p>
    `,
  },
  
  // PDF filenames (these will be looked for in /public/docs/egta-board-2025/)
  attachments: [
    'Board_Topic_Summary.pdf',
    'AI_Change_Playbook.pdf',
    'Executive_QA_Prep.pdf',
    'Risk_Governance_Primer.pdf',
  ],
};
